module.exports = __webpack_public_path__ + "static/media/LogoDavinci.e293dfcd.png";